import headMeta from '@/constants/headMeta';

const MetaHead = {
  data() {
    return {
      meta: {
        title: '',
        description: '',
        image: {
          url: '',
        },
      },
    };
  },
  head() {
    return {
      title: this.meta.title,
      meta: [
        { hid: 'description', name: 'description', content: this.meta.description },
        { property: 'og:title', content: this.meta.title },
        { property: 'og:description', content: this.meta.description },
        { property: 'og:url', content: `${headMeta.domain}${this.$router.currentRoute.path}` },
        { property: 'og:site_name', content: headMeta.siteName },
        { property: 'og:type', content: headMeta.type },
        { property: 'og:image', content: this.meta.image.url },
      ],
    };
  },
};

export default MetaHead;
